export default __webpack_public_path__ + "static/media/ApAutomation.d6bd377d.png";